import React, { Component } from 'react';

class Submission extends Component {
  constructor(props) {
    super(props)
    this.state = {loading: false}
  }

  render() {
    return (<div>Submission</div>)
  }
}


export default Submission



// WEBPACK FOOTER //
// ./src/views/Submission/submission.js